import { IkeConfig } from '../..';
import { IkeLog, IkeLogStreamType, IkeLogType } from '../../../log';
import { LogConfig } from '../log';

export const OfficeBase = new IkeConfig(null, null);

OfficeBase.set('storage.bucket', 'dragon-files');
OfficeBase.set('storage.private.bucket', 'dragon-files-private');
OfficeBase.set('aws.region', 'us-east-1');

/**
 * connect also bounds the wait for a free pooled socket, so it must stay short:
 * a starved pool has to fail fast rather than hang requests into the ELB's 60s
 * idle timeout. http is the inactivity timeout for in-flight transfers.
 * sockets.max is the keep-alive pool size per AWS SDK client; streamed S3
 * bodies hold a socket until the client finishes downloading.
 */
OfficeBase.set('aws.timeout.connect', 5000);
OfficeBase.set('aws.timeout.http', 60000);
OfficeBase.set('aws.sockets.max', 50);

OfficeBase.set('database.query.timeout', 15000);
OfficeBase.set('database.query.log.warn', 500);
OfficeBase.set('database.query.log.error', 2500);

OfficeBase.set('auth0.enabled', true);

OfficeBase.set('ike.access.license.cache.enabled', true);
OfficeBase.set('ike.access.license.cache.ttl.seconds', 3600); // 1 hour
OfficeBase.set('ike.access.license.cache.failure.ttl.seconds', 60); // 1 minute for failed/erroring checks

OfficeBase.set('vendor.google.mapsReleaseChannel', 'quarterly');

OfficeBase.set('swagger.enabled', false);

// Verify Workbench (PoleOS) origin. Empty by default (local/offline); the deployed
// envs set their PoleOS origin in the office.<env>.ts files (UFO-148).
OfficeBase.set('verify.workbench.url', '');

LogConfig.register(OfficeBase, IkeLogType.FUNCTION, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
